export const accountMenuItems = [
    { to: "usuario", label: "Datos de usuario" },
    { to: "direcciones", label: "Direcciones" },
    { to: "Pedidos", label: "Pedidos" },
    { to: "Facturas", label: "Facturas" },
    { to: "Albaranes", label: "Albaranes" },
    { to: "Favoritos", label: "Favoritos" },
    { to: "Alertas", label: "Alertas y notificaciones" },
    { to: "pendientes", label: "Productos pendientes" },
];

// Secciones visibles según las features del tenant: "Productos pendientes" solo
// existe donde la feature está activada (config pendingOrders.enabled, solo LeonVet).
export const visibleAccountMenuItems = (tenantConfig) =>
    accountMenuItems.filter((item) =>
        item.to !== "pendientes" || (tenantConfig?.pendingOrders?.enabled ?? false));
